import { render, staticRenderFns } from "./date-range-valueFormat-editor.vue?vue&type=template&id=48bb8046&scoped=true&"
import script from "./date-range-valueFormat-editor.vue?vue&type=script&lang=js&"
export * from "./date-range-valueFormat-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bb8046",
  null
  
)

export default component.exports